import { render } from "./Authorization.vue?vue&type=template&id=37de602e&scoped=true&ts=true"
import script from "./Authorization.vue?vue&type=script&lang=ts"
export * from "./Authorization.vue?vue&type=script&lang=ts"

import "./Authorization.vue?vue&type=style&index=0&id=37de602e&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37de602e"]])

export default __exports__